import { render, staticRenderFns } from "./Jobs.vue?vue&type=template&id=06773788&scoped=true"
import script from "./Jobs.vue?vue&type=script&lang=js"
export * from "./Jobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06773788",
  null
  
)

export default component.exports